// Helpers for multi-select dropdowns whose backend field is a single string column
// (e.g. asset / affectedAntenna). Selected values are stored as "A, B, C".

export const joinMulti = (
  val: string | number | Array<string | number> | null | undefined,
): string => {
  if (Array.isArray(val)) return val.map(String).join(", ");
  return val == null ? "" : String(val);
};

export const splitMulti = (
  val: string | string[] | null | undefined,
): string[] => {
  if (Array.isArray(val)) return val;
  return val
    ? val
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
    : [];
};
